<template>
	<TypographyTitle :level="2">
		{{ $t('stats.header') }}
	</TypographyTitle>

	<Table
		:columns="columns"
		:data-source="roverStats"
		:pagination="false"
		:bordered="true"
		:loading="isLoading"
	>
	</Table>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, Table } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import Api from '@/api/Api';

import { useUserStore } from '@/stores/user';

import { datetimeToString } from '@/components/common/dateUtils';

import TranslationUtils from '@/i18n/TranslationUtils';

export default {
	components: {
		TypographyTitle, Table,
	},
	setup() {
		const { t } = useI18n();
		const userStore = useUserStore();
		const columns = TranslationUtils.addTranslatedField(
			userStore.roversStatsTableColumns,
			'dataIndex', 'title',
			'stats.tableColumns',
		);
		const roverStats = ref([]);
		const isLoading = ref(true);
		const updateStats = () => {
			isLoading.value = true;
			Api.roverStatsGet(response => {
				if (response.status === 'ok') {
					roverStats.value = response.stats.map(item => ({
						...item,
						last_online_datetime: datetimeToString(item.last_online_datetime, t('common.never')),
						added_datetime: datetimeToString(item.added_datetime),
					}));
				}
				isLoading.value = false;
			});
		};
		onMounted(updateStats);
		return {
			columns,
			roverStats,
			isLoading,
		};
	},
}
</script>
